import { render, staticRenderFns } from "./match-edit.vue?vue&type=template&id=69d99c16&scoped=true"
import script from "./match-edit.vue?vue&type=script&lang=js"
export * from "./match-edit.vue?vue&type=script&lang=js"
import style0 from "./match-edit.vue?vue&type=style&index=0&id=69d99c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d99c16",
  null
  
)

export default component.exports